import { render, staticRenderFns } from "./StockChildrenList.vue?vue&type=template&id=2b6e3f6c&"
import script from "./StockChildrenList.vue?vue&type=script&lang=ts&"
export * from "./StockChildrenList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports